@if (regionList) {
  <p-select
    (onChange)="onRegionChange($event)"
    [options]="regionList"
    [(ngModel)]="region"
    [filter]="true"
    filterBy="label, value"
    [disabled]="disabled()"
    [placeholder]="region || 'Please select region'"
  >
  </p-select>
}
